export default __webpack_public_path__ + "static/media/group_1.617b56fd.png";